import { render } from "./CounterpartyCreateForm.vue?vue&type=template&id=2628ef16&scoped=true"
import script from "./CounterpartyCreateForm.vue?vue&type=script&lang=js"
export * from "./CounterpartyCreateForm.vue?vue&type=script&lang=js"

import "./CounterpartyCreateForm.vue?vue&type=style&index=0&id=2628ef16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2628ef16"]])

export default __exports__